import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';

import {
    Container,
    Grid,
    Paper,
    Box,
    Button,
    CircularProgress,
    Hidden
} from '@material-ui/core';
import { Last10RechargeReport } from 'Pages/InnerPages/Report/Last10RechargeReport';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PayoutTransactionV1 as PAYOUT_TRANSACTION } from 'Components/Api/TransactionAPI';
import { SelectSuccessPayoutTransaction as SUCCESS_PAYOUT_TRANSACTION } from 'Components/Api/TransactionReportAPI';
import { PAYOUT, IMPS_OPERATOR_ID } from 'Components/Helper/Messages';

import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
import { GetBene as GET_BENE } from 'Components/Api/EzyPayPayoutAPI';
import ReactTable from 'Components/ReactTable/ReactTable';
import HOCLoader from 'Components/Loader/HOCLoader';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';

import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
import { Select as BANK_SELECT } from 'Components/Api/DMTBankAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { AddBeneficiary as BENE_ADD } from 'Components/Api/EzyPayPayoutAPI';
import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';

const CustomContainer = HOCLoader(Container);
export const E_Payout = () => {
    const formRef = useRef();
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }
    const classes = commonStyle();
    const history = useHistory();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [transactions, setTransactions] = useState([]);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [ResponseAlert, setResponseAlert] = useState({});
    const [confirmAlertMessage, setConfirmAlertMessage] = useState('');
    const [serviceCode, setServiceCode] = useState(PAYOUT);
    const [status, setStatus] = useState('PROCESS');
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [TakeCount, setTakeCount] = useState(25);
    const [totalCount, setTotalCount] = useState(0);
    const [isReadOnly, setReadOnly] = useState(false);
    const [bankList, setBankList] = useState([]);
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);

    const [bankDefault, setBankDefault] = useState({
        Name: 'Select Bank',
        DefaultIFSC: ''
    });

    const [OperatorDefault, setOperatorDefault] = useState({
        OperatorID: 0,
        OperatorName: 'Select Operator'
    });
    const initialValues = {
        ServiceID: PAYOUT,
        Bank: bankDefault,
        AccountNo: '',
        IFSC: '',
        Amount: '',
        InWords: '',
        BeneName: '',
        Mobile: ''
    };

    const [FormObj, setFormObj] = useState(initialValues);

    useEffect(() => {
        SelectBene();
        fetchConsumerNumberFontSize();
        selectBank();
        createColumns();
        setLoading(false);
    }, []);

    const TransferValidation = Yup.object({
        OperatorID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator'),

        AccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        Amount: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'amount')
            .min(1, PLEASE_PROVIDE_VALID + 'amount')
            .max(500000, PLEASE_PROVIDE_VALID + 'amount')
    });

    const SelectBene = async () => {
        setIsError(false);
        setTransactions([]);
        const response = await GET_BENE();
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            if (
                response.data === '~Requested mobile no not registered with us'
            ) {
                history.push('/AddContact');
            }
            setResponseMessage(response.data);

            return;
        }

        var data = JSON.parse(response.data);

        if (data.length < 0) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage('No transactions found');
            return;
        }
        setTransactions(data);
    };

    const TransferConfirmation = async (values) => {
        let jsonObj = {
            ServiceID: PAYOUT,
            AccountNo: values[3],
            BankName: values[2],
            IFSC: values[5],
            BeneficiaryID: values[6],
            Amount: values[4],
            BeneName: values[1],
            OperatorID: IMPS_OPERATOR_ID,
            PaymentType: '',
            IsVerify: false
        };

        setConfirmAlertRequest(jsonObj);

        setIsError(false);
        var errorValidation = false;

        await TransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);
            selectSuccessPayoutTransaction();
            return;
        });

        if (errorValidation === true) return;

        let msg = `Please confirm payout details - \n\nAccountNo : ${values[3]}\nIFSC : ${values[6]}\nAmount : ${values[5]}`;

        setConfirmAlertMessage(msg);
        setIsAlertOpen(true);
    };

    const Payout = async () => {
        setResponseMessage('');
        setIsError(false);

        var requestObj = JSON.stringify(confirmAlertRequest);

        setLoading(true);
        var response = await PAYOUT_TRANSACTION(requestObj);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            SelectBene();
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        let dataSuccess = JSON.parse(response.data);

        setSeverity('success');
        setResponseMessage(dataSuccess.Message);
        setIsError(true);
        setStatus(dataSuccess.Status);
        setResponseAlert(dataSuccess);
        setIsResponseAlertOpen(true);

        if (dataSuccess.Status === 'SUCCESS') {
            setReadOnly(true);
        }

        reset(
            dataSuccess.BeneficiaryName,
            confirmAlertRequest.IsVerify,
            confirmAlertRequest.AccountNo,
            confirmAlertRequest.PaymentType,
            confirmAlertRequest.OperatorID,
            confirmAlertRequest.IFSC,
            confirmAlertRequest.BeneficiaryID,
            confirmAlertRequest.BankName
        );

        SelectBene();
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'ID',
            srno: true
        });
        columns.push({
            label: 'BeneName',
            name: 'Name'
        });
        columns.push({
            label: 'Bank',
            name: 'BankName'
        });

        columns.push({
            label: 'AccountNo',
            name: 'AccountNo'
        });
        // columns.push({
        //     label: 'Operator',
        //     name: 'OperatorID',
        //     dropdown: true,
        //     list: PayoutOperators
        // });

        columns.push({
            label: 'Amount',
            name: 'Amount',
            length: 6,
            editableWithNumberOnly: true
        });

        columns.push({
            label: 'IFSC',
            name: 'IFSC'
        });

        columns.push({
            label: 'BeneficiaryID',
            name: 'BeneficiaryID',
            hide: true
        });

        columns.push({
            label: 'Transfer',
            name: 'BeneficiaryID',
            buttonTitle: 'Transfer',
            statusIndex: 2,
            buttonWithTitle: true,
            callback: (value) => {
                TransferConfirmation(value);
            }
        });

        setMainColumns(columns);
    };

    const selectSuccessPayoutTransaction = async () => {
        setLoading(true);
        setIsError(false);

        setTransactions([]);
        var response = await SUCCESS_PAYOUT_TRANSACTION();
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);

        if (data.length < 0) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage('No transactions found');
            return;
        }

        setTransactions(data);
    };

    const selectBank = async () => {
        const response = await BANK_SELECT();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        let objWithSelectAll = [bankDefault, ...data];

        setBankList(objWithSelectAll);
    };
    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setResponseMessage('');
        setIsError(false);

        var request = {
            BeneName: values.BeneName,
            BankName: values.Bank.Name,
            BankID: values.Bank.BankID,
            AccountNo: values.AccountNo,
            IFSC: values.IFSC,
            AccountType: values.AccountType
        };

        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await BENE_ADD(requestObj);

        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }

        let dataSuccess = JSON.parse(response.data);
        setSeverity('success');
        setResponseMessage(dataSuccess.Message);
        reset();
        SelectBene();
    };

    const FormValidationSchema = Yup.object({
        Bank: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'bank')
            .required(PLEASE_SELECT_VALID + 'bank')
            .shape({
                Name: Yup.string()
                    .nullable(PLEASE_SELECT_VALID + 'bank')
                    .required(PLEASE_SELECT_VALID + 'bank'),
                DefaultIFSC: Yup.string()
                    .nullable(PLEASE_SELECT_VALID + 'bank')
                    .required(PLEASE_SELECT_VALID + 'bank')
            }),
        AccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC'),

        BeneName: Yup.string().required(PLEASE_PROVIDE_VALID + 'name')
    });

    const reset = () => {
        setBankDefault({
            Name: 'Select Bank',
            DefaultIFSC: ''
        });

        setOperatorDefault({
            OperatorID: 0,
            OperatorName: 'Select Operator'
        });

        setFormObj({
            ServiceID: PAYOUT,
            Bank: bankDefault,
            Operator: OperatorDefault,
            BeneficiaryID: '',
            BankName: '',
            AccountNo: '',
            IFSC: '',
            Amount: '',
            InWords: '',
            BeneName: ''
        });
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={FormObj}
                render={({ setFieldValue, handleSubmit }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <h2 className={classes.PaperHead_h2}>
                                        Add Beneficiary
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Hidden xsUp>
                                                    <MaterialTextField
                                                        label="IsNameVerified"
                                                        name="IsNameVerified"
                                                        type="text"
                                                        placeholder="IsNameVerified"
                                                    />
                                                </Hidden>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Field
                                                        component={
                                                            AutoCompleteTextView
                                                        }
                                                        defaultValue={
                                                            bankDefault
                                                        }
                                                        FieldName="Bank"
                                                        name="Bank"
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            setFieldValue(
                                                                'IFSC',
                                                                value.DefaultIFSC
                                                            );
                                                            setBankDefault({
                                                                Name:
                                                                    value.Name,
                                                                DefaultIFSC:
                                                                    value.DefaultIFSC
                                                            });
                                                        }}
                                                        options={bankList}
                                                        getOptionLabel={(
                                                            option
                                                        ) => option.Name}
                                                        getOptionSelected={(
                                                            option,
                                                            value
                                                        ) =>
                                                            option.Name ===
                                                            value.Name
                                                        }
                                                        textFieldProps={{
                                                            label: 'Bank'
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="IFSC"
                                                        name="IFSC"
                                                        type="text"
                                                        length={11}
                                                        placeholder="IFSC"
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Account No."
                                                        name="AccountNo"
                                                        autoComplete="new-password"
                                                        type="text"
                                                        length={20}
                                                        placeholder="Account No."
                                                        typed_length={1}
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={9}
                                                    lg={9}
                                                >
                                                    <MaterialTextField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Confirm Account No."
                                                        name="ConfirmAccountNo"
                                                        type="text"
                                                        length={20}
                                                        placeholder="Confirm Account No."
                                                        typed_length={1}
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Bene Name"
                                                        name="BeneName"
                                                        type="text"
                                                        placeholder="Bene Name"
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>

                                        <Grid className={classes.footerGrid}>
                                            <Box
                                                className={classes.flexReverse}
                                            >
                                                <div
                                                    className={
                                                        classes.SubmitWrapper
                                                    }
                                                    style={{
                                                        marginLeft: '10px'
                                                    }}
                                                >
                                                    <Button
                                                        type="submit"
                                                        title="Add"
                                                        className={
                                                            classes.CustomPrimaryButtonStyle
                                                        }
                                                        onClick={(e) => {
                                                            setFieldValue(
                                                                'isAddOnly',
                                                                true
                                                            );
                                                            handleSubmit(e);
                                                        }}
                                                        disabled={loading}
                                                    >
                                                        Add
                                                    </Button>
                                                    {loading && (
                                                        <CircularProgress
                                                            size={24}
                                                            className={
                                                                classes.buttonProgress
                                                            }
                                                        />
                                                    )}
                                                </div>

                                                <Button
                                                    type="reset"
                                                    title="Reset"
                                                    className={
                                                        classes.CustomDangerButtonStyle
                                                    }
                                                    onClick={() => {
                                                        reset(
                                                            '',
                                                            false,
                                                            '',
                                                            0,
                                                            '',
                                                            ''
                                                        );
                                                    }}
                                                >
                                                    Reset
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </Grid>

                            <Grid item sx={12} sm={12} md={8} lg={8}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <ReactTable
                                        data={transactions}
                                        columns={mainColumns}
                                        count={totalCount}
                                        rowsPerPage={TakeCount}
                                        serverSide={true}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                }}
            />

            <Last10RechargeReport ServiceID={serviceCode} refreshRandom={1} />

            {isAlertOpen ? (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="Payout Confirmation"
                    message={confirmAlertMessage}
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        Payout(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                        selectSuccessPayoutTransaction();
                    }}
                />
            ) : null}

            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    title={status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        setIsResponseAlertOpen(false);
                        selectSuccessPayoutTransaction();
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
